import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';
import Education from './education';
import Experience from './experience';
import Skills from './skills';

export default class Resume extends Component {
  render() {
    return(
      <div>
        <Grid>
          <Cell col={4}>
            <div style={{textAlign: 'center'}}>
              <img
                src="https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/portfolio.png"
                alt="avatar"
                style={{height: '200px'}}
                 />
            </div>

            <h2 style={{paddingTop: '2em'}}>nicols Co</h2>
            <h4 style={{color: 'grey'}}>Programmer</h4>
            <hr style={{borderTop: '3px solid #833fb2', width: '50%'}}/>
            <p>
            I love my code to be elegant and efficient. Logic should be enough
            straightforward to make mistakes difficult
            to hide; dependencies are minimal to simplify maintenance; error handling - complete in accordance with the developed
            strategy; performance close
            to the best so as not to tempt people to pollute the code with unprincipled optimizations.
            Clean code solves one problem well.</p>
            <hr style={{borderTop: '3px solid #833fb2', width: '50%'}}/>
            <h5>Address</h5>
            <p>Russia, Moscow, settlement Ryazanovskoe Salkovo village, 108822</p>
            <h5>Phone</h5>
            <p>8 (917) 573-20-52</p>
            <h5>Email</h5>
            <p><a href='mailto:hru91nik@mail.ru'>hru91nik@mail.ru</a></p>
            <h5>Web</h5>
            <a href='https://nkhrulev.github.io' target='_blank'>nkhrulev.github.io</a>
            <hr style={{borderTop: '3px solid #833fb2', width: '50%'}}/>
          </Cell>
          <Cell className="resume-right-col" col={8}>
            <h2>Education</h2>

            <Education
              startYear={2009}
              endYear={2014}
              schoolName="My University"
              schoolDescription="National Research Technological University MiSiS - Russian Technical University; the first university in the country to receive the status of the National Research Technological University, the best university in Russia in 2019 according to Forbes. Today NITU MiSiS includes 9 institutes and 6 branches, 4 of which work in Russia and 2 abroad."
               />

            <hr style={{borderTop: '3px solid #e22947'}} />

            <h2>Experience</h2>

            <Experience
              startYear={2014}
              endYear={new Date().getFullYear()}
              jobName="Job"
              jobDescription="Development of new functionality, review / refactoring code. Work with containers, mvc patterns. Adhere to a flexible methodology."
              />

            <hr style={{borderTop: '3px solid #e22947'}} />
            
            <h2>Skills</h2>

            <Skills skill="net core" progress={100} />
            <Skills skill="javascript" progress={100} />
            <Skills skill="html/css" progress={80} />
            <Skills skill="nodejs" progress={50} />
            <Skills skill="angular" progress={35} />
            <Skills skill="react" progress={55} />

          </Cell>
        </Grid>
      </div>
    )
  }
}